import { useQuery } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

export const offerVendorAccountQueryKeys = {
  all: ['offerVendorAccount'] as const,
  byOffer: (offerId: string) => [...offerVendorAccountQueryKeys.all, offerId] as const,
};

export function useOfferVendorAccount(offerId: string | null) {
  return useQuery({
    queryKey: offerVendorAccountQueryKeys.byOffer(offerId ?? ''),
    queryFn: () => OffersService.getOffer(offerId),
    select: (response) => response.result?.vendor_account_id ?? undefined,
    enabled: !!offerId,
  });
}
